import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { AxiosResponse } from "axios";
import http from "../common/http-common";

// TODO: replace this with API response once it's ready
export const TaxSlipDefinitionsService = {
  create: async (
    requestPayload: any
  ): Promise<any | IServerError | IResponse> => {
    if (requestPayload.id) {
      
      const response: AxiosResponse<any> = await http.put<any>(
        `/v1/taxslip-definitions/${requestPayload.id}`, requestPayload);

      if (response.status === 200) {
        return response.data;
      }
      else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
    }


    const response: AxiosResponse<any> =
      await http.post<any>(
        "/v1/taxslip-definitions/",
        requestPayload
      );

    if (response.status === 201) {
    
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  delDefinitionsList: async (
    DefinitionsListId: number
  ): Promise<string | IServerError | IResponse> => {
    
    const response: AxiosResponse<string> = await http.delete<string>(
      `/v1/taxslip-definitions/${DefinitionsListId}/`
    );

    if (response.status === 204) {
      return "Definitions List has been deleted successfully";
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getList: async (
    params: IGetListRequest
  ): Promise<any | IServerError | IResponse> => {
    //  const fixedResponse: any = {
    //    "page": 1,
    //    "size": 5,
    //    "total": 2,
    //    "items": [
    //      {
    //        "id": "ab8ccece-16c1-44e9-ba86-2990eefb178c",
    //        "name": "Client Profile",
    //        "slug": "client-profile"
    //      },
    //      {
    //        "id": "4e3823aa-c2e4-45aa-aaaf-9ba1b1486acc",
    //        "name": "Sales Tax - CRA",
    //        "slug": "sales-tax-cra"
    //      },
    //      {
    //        "id": "4e3823aa-c2e4-45aa-aaaf-9ba1b1486acd",
    //        "name": "T4/RL-1",
    //        "slug": "t4-rl-1"
    //      }
    //    ],
    //    "keyField": {
    //      "field": "id",
    //      "templateUrl": "/taxslip-definitions/setup/id"
    //    },
    //    "headerColumns": [
    //      {
    //        "field": "name",
    //        "headerName": "Name",
    //        "description": "name",
    //        "flex": 1,
    //        "hide": false,
    //        "hideable": false,
    //        "sortable": true,
    //        // "sortingOrder": "asc",
    //        "resizable": false,
    //        "type": "string",
    //        "align": "left",
    //        "headerAlign": "left",
    //        "hideSortIcons": false,
    //        "disableColumnMenu": true,
    //        "disableReorder": true,
    //        "disableExport": true,
    //        "maskable": false,
    //        // "isFixed": true,
    //        "sequence": 0
    //      },
    //      {
    //        "field": "slug",
    //        "headerName": "Slug",
    //        "description": "Slug",
    //        "flex": 1,
    //        "hide": false,
    //        "hideable": false,
    //        "sortable": true,
    //        // "sortingOrder": "asc",
    //        "resizable": false,
    //        "type": "string",
    //        "align": "left",
    //        "headerAlign": "left",
    //        "hideSortIcons": false,
    //        "disableColumnMenu": true,
    //        "disableReorder": true,
    //        "disableExport": true,
    //        "maskable": false,
    //        // "isFixed": true,
    //        "sequence": 1
    //      }
    //    ]
    //  }
    //  return new Promise(resolve => setTimeout(() => resolve(fixedResponse), 1000));

    const response: AxiosResponse<any> =
      await http.get<any>(
        `/v1/taxslip-definitions/?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`
      );
    if (response.status === 200) {
      
      return response.data;
    } else if (response.status === 400) {
      return {
        status: false,
        message: "Bad Request.",
        error: true,
      };
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getById: async (id: string | undefined): Promise<any | IServerError | IResponse | null> => {
    if (id) {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/taxslip-definitions/${id}/`);
  
      if (response.status === 200) {
        return response.data;
      }
      else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
  
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    }

    return null;
  },
};
